import React, { useState } from 'react'
import { Button, Modal } from 'syngenta-react-components'
import clear from '../../assets/icons/clear.svg'

const ModalContent = props => {
  return (
    <div className='w100% h100% bgc-white bd1-s-lightgray bxshmodal bdrs-4 mb40'>
      {props.children}
    </div>
  )
}

const BorderLine = () => {
  return (
    <div className='bgc-lightgray h2' />
  )
}

const ModalHeader = ({ title, onClose }) => {
  return (
    <>   
      <div className='df jcsb p15'>
        <span className='fz20 ml16 fw600'>{title}</span>
        <button className='bdnone m0 bgc-t' onClick={onClose}>
          <img  src={clear} alt='cancel button'/>
        </button>
      </div>
      <BorderLine />
    </>
  )
}

const ModalFooter = ({ buttonLabel, onClose, onDelete }) => {
  return (
    <>
      <div className='df jcsb ml25 mr25 mt10'>
        {onDelete ? <Button styleType='error' onClick={onDelete}>Delete</Button> : null }
        <Button styleType='success' onClick={onClose}>{buttonLabel}</Button>
      </div>
    </>
  )
}

const Section = props => {
  return (
    <>
      <div className='df fxdr fxww w100% p15'>
        {props.children}
      </div>
      <BorderLine />
    </>
  )
}

const Column = props => {
  return (
    <div className='df fxdrc flx1'>
      {props.children}
    </div>
  )
}

const DataRow = ({ label, data }) => {
  return (
    <div className="df fxdrc mb20">
      <span className="mb5 fz15 fw600 w100% c-darkgray">{label}</span>
      <span className="w100%">{data}</span>
    </div>
  )
}
  
const ScaleTicketDetails = ({ data }) => {
  const [showModal, setShowModal] = useState(true) 
  const { 
    scale_ticket_number,
    grower_name,      
    scale_ticket_date,
    gross_quantity,
    net_quantity,
    test_weight,
    moisture,
    damage,
    foreign_material,
    rapid_visco_analyzer,
    gross_weight,
    bill_of_lading,
    tare_weight,
    net_weight,
    created
  } = data
  const convertDateFromISO = date => {
    if (typeof date === 'string') {
      let returnDate = date && date.split('T')[0].split('-').reverse()
      returnDate = returnDate[1]+'/'+returnDate[0]+'/'+returnDate[2]
      return returnDate
    }
  }

  return (
    <div>
      <Modal
        autoHeight
        show={showModal}
        handleClose={()=>setShowModal(false)}        
      >
        <ModalContent>
          <ModalHeader title='Scale Ticket Details' onClose={()=>setShowModal(false)} />
          <Section>
            <Column>
              <DataRow label='Grower' data={grower_name} />
              <DataRow label='Ticket Date' data={scale_ticket_date} />
              <DataRow label='Gross Quantity (bushels)' data={gross_quantity} />
              <DataRow label='Test Weight' data={test_weight} />
              <DataRow label='Damage' data={damage} />
              <DataRow label='RVA' data={rapid_visco_analyzer} />
            </Column>
            <Column>
              <DataRow label='Ticket Number' data={scale_ticket_number} />
              <DataRow label='Bill of Lading (BOL)' data={bill_of_lading} />
              <DataRow label='Net Quantity (bushels)' data={net_quantity} />
              <DataRow label='Moisture' data={moisture} />
              <DataRow label='Foreign Material' data={foreign_material} />
            </Column>
          </Section>
          <Section>
            <Column>
              <DataRow label='Gross Lbs' data={gross_weight} />
              <DataRow label='Net Lbs' data={net_weight} />
            </Column>
            <Column>
              <DataRow label='Tare Lbs' data={tare_weight} />
            </Column>
          </Section>
          <Section>
            <Column>
              <DataRow label='Date of File Upload' data={convertDateFromISO(created)} />
            </Column>
          </Section>
          <ModalFooter buttonLabel='Close' onClose={() => setShowModal(false)} />
        </ModalContent> 
      </Modal>
    </div>
  )
}

export default ScaleTicketDetails 